/**
 * Our Values Block - Frontend JavaScript
 * Auto-loop functionality that stops on user interaction
 */
document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.our-values');

    sections.forEach(function(section) {
        const titleButtons = section.querySelectorAll('.our-values__title-btn');
        const imageSlides = section.querySelectorAll('.our-values__image-slide');
        const descriptionSlides = section.querySelectorAll('.our-values__description-slide');
        const paginationIndicator = section.querySelector('.our-values__pagination-indicator');

        if (titleButtons.length === 0) return;

        let currentIndex = 0;
        let autoLoopInterval = parseInt(section.dataset.autoLoopInterval) || 4000;
        let loopTimer = null;
        let isLooping = true;

        // Update active state
        function setActiveSlide(index) {
            currentIndex = index;

            // Update title buttons
            titleButtons.forEach(function(btn, i) {
                if (i === index) {
                    btn.classList.add('is-active');
                    btn.setAttribute('aria-pressed', 'true');
                } else {
                    btn.classList.remove('is-active');
                    btn.setAttribute('aria-pressed', 'false');
                }
            });

            // Update image slides
            imageSlides.forEach(function(slide, i) {
                if (i === index) {
                    slide.classList.add('is-active');
                } else {
                    slide.classList.remove('is-active');
                }
            });

            // Update description slides
            descriptionSlides.forEach(function(slide, i) {
                if (i === index) {
                    slide.classList.add('is-active');
                } else {
                    slide.classList.remove('is-active');
                }
            });

            // Update pagination indicator position
            if (paginationIndicator) {
                const totalItems = titleButtons.length;
                const indicatorWidth = 100 / totalItems;
                const position = index * indicatorWidth;
                paginationIndicator.style.transform = `translateX(${position * totalItems / 100 * 100}%)`;
            }
        }

        // Go to next slide
        function nextSlide() {
            const nextIndex = (currentIndex + 1) % titleButtons.length;
            setActiveSlide(nextIndex);
        }

        // Start auto-loop
        function startLoop() {
            if (loopTimer) clearInterval(loopTimer);
            loopTimer = setInterval(nextSlide, autoLoopInterval);
            isLooping = true;
        }

        // Stop auto-loop
        function stopLoop() {
            if (loopTimer) {
                clearInterval(loopTimer);
                loopTimer = null;
            }
            isLooping = false;
        }

        // Handle title button clicks
        titleButtons.forEach(function(btn) {
            btn.addEventListener('click', function() {
                const index = parseInt(btn.dataset.index);
                stopLoop(); // Stop auto-loop when user interacts
                setActiveSlide(index);
            });
        });

        // Handle keyboard navigation
        section.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                e.preventDefault();
                stopLoop();
                const nextIndex = (currentIndex + 1) % titleButtons.length;
                setActiveSlide(nextIndex);
                titleButtons[nextIndex].focus();
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                e.preventDefault();
                stopLoop();
                const prevIndex = (currentIndex - 1 + titleButtons.length) % titleButtons.length;
                setActiveSlide(prevIndex);
                titleButtons[prevIndex].focus();
            }
        });

        // Start auto-loop on page load
        startLoop();

        // Pause on hover (optional - for better UX)
        section.addEventListener('mouseenter', function() {
            if (isLooping) {
                clearInterval(loopTimer);
            }
        });

        section.addEventListener('mouseleave', function() {
            if (isLooping) {
                startLoop();
            }
        });

        // Handle visibility change (pause when tab is not visible)
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                if (loopTimer) clearInterval(loopTimer);
            } else if (isLooping) {
                startLoop();
            }
        });
    });
});
